import { getBroadcastRouteMatch } from 'actions/utils';
import setStreamStatus from 'actions/Broadcast/setStreamStatus';
import {
  getClientMethodFromTags,
  handleClientMethods,
  parseIfJSON
} from '@shoflo/studio-redux/utils/realtimeUtils';

export function processIncomingRealtimeMessage() {
  const store = this.store;
  const payload = this.payload;
  const snsMessage = parseIfJSON(payload);
  const { params } = getBroadcastRouteMatch(store.getState);
  const broadcastId = snsMessage?.params?.broadcastId;

  if (params.broadcastId !== broadcastId) {
    return;
  }

  const clientMethod = getClientMethodFromTags(snsMessage?.tags);

  handleClientMethods(clientMethod, store, snsMessage, setStreamStatus);
}
